import React, {useMemo, useState} from 'react';
import SPSelectWithEnum from '../../../base/SPSelectWithEnum'
import {Form , Input, Checkbox, Col, Row, DatePicker, InputNumber} from "antd";
import MyCascader from "../../../../product-price/base/vehicle-cascader";
import SPButton from 'components/carRental/base/SPButton';
import SPSelectWithApi from "../../../base/SPSelectWithApi";
import moment from "moment";
import ChooseRangDay from "./choose-rang-day";
interface IComponentProps {
  enums: any;
  form: any;
}

const firstTypeArr = [4001, 4002, 4007, 4008]
const secondTypeArr = [4009 ]
const threeTypeArr = [4010]
const fourTypeArr = [4003]
const fiveTypeArr = [4004]
const sixTypeArr = [4006]
const fuwuzhengce = [4005]

const carMaxLenArr1 = [4001, 4002]

const priceMap: any = {
  4001: ['deposit_broken'],
  4002: ['deposit_illegal'],
  4007: ['price_detail', 'weekday', 'price'],
  4008: ['price_detail', 'weekend', 'price'],
}

const weekArr = [
  {
    label: '周一',
    value: 1
  },
  {
    label: '周二',
    value: 2
  },
  {
    label: '周三',
    value: 3
  },
  {
    label: '周四',
    value: 4
  },
  {
    label: '周五',
    value: 5
  },
  {
    label: '周六',
    value: 6
  },
  {
    label: '周日',
    value: 7
  }
]


const BatchSettings: React.FC<IComponentProps> = (props) => {
  const {  enums, form } = props
  const [modifyProject, setModifyProject] = useState<any>('');
  const [chooseWeekArr, setChooseWeekArr] = useState<any[]>([]);
  const [chooseWeekendArr, setChooseWeekendArr] = useState<any[]>([5, 6, 7]);
  const [vipFlag, setVipFlag] = useState<any>(true);
  const [params, setParams] = useState<any>({});

  const changeModifyProject = (e: any) => {
    setModifyProject(e);
  }

  const projectArr = useMemo(() => {
   return enums['event_price_mod_up']
  }, [enums])

  const carMaxNum = useMemo(() => {
     const res = enums?.['f_max_num_car_price']?.find((item: any) => { return item.value === 'car_price_max' })
     return res?.key || 50000
  }, [enums])

  const dayMaxNum = useMemo(() => {
    const res = enums?.['f_max_num_car_price']?.find((item: any) => { return item.value === 'day_price_max' })
    return res?.key || 5000
  }, [enums])

  const priceLabel = useMemo(() => {
    let text = ''
    projectArr.forEach((item: any) => {
      if (item.key === modifyProject) {
        text = item.value
      }
    })
    return text
  }, [projectArr, modifyProject])




  const findOverArr = (arr: any) => {
    const res = []
    for (let i = 1; i <= 7; i++) {
      if (!arr.includes(i)) {
        res.push(i)
      }
    }
    return res
  }

  const onWeekChange = (e: any) => {
    const res = findOverArr(e)
    if (res) {
      form.setFieldValue('price_detail', {
        weekend: {
          day: res
        },
        weekday: {
          day: e
        }
      })
      setChooseWeekendArr(res)
    }
    setChooseWeekArr(e)
  }

  const onWeekendChange = (e: any) => {
    const res = findOverArr(e)
    if (res) {
      form.setFieldValue('price_detail', {
        weekday: {
          day: res
        },
        weekend: {
          day: e
        }
      })
      setChooseWeekArr(res)
    }
    setChooseWeekendArr(e)
  }

  const setVipFn = (flag: boolean) => {
    setVipFlag(flag)
  }

  const changeStore = (e: any) => {
    setParams({
      store_code: e
    })
  }

  return (
    <>
      <Form.Item label={'修改项目'} rules={[{required: true, message: '请选择修改项目'}]} name={['up_type']}  style={{
        width: '600px' }}>
        <SPSelectWithEnum
            placeholder="请选择修改项目"
            onChange={changeModifyProject}
            enums={enums}
            enumKey={'event_price_mod_up'}/>
      </Form.Item>

      <Form.Item label={'门店'}  style={{
        width: '600px' }}>
        <SPSelectWithApi
            onChange={changeStore}
            allowClear={true}
            url={'/rental/scm/store/list'}
            labelKey='store_name'
            valueKey='store_code'
            placeholder='请选择'
        >
        </SPSelectWithApi>

      </Form.Item>

      <Form.Item label={'车型商品'}
                 rules={[{required: true, message: '请选择车型商品'}]} name={['price_mod_codes']}  style={{
        width: '600px' }}>

        <SPSelectWithApi
            showSearch
            filterOption={(input:any, option: any) => (option?.label ?? '').includes(input)}
            enums={enums}
            depLoadKeys={[params.store_code]}
            params={params}
            needEnumMap={{
              veh_num_type: 'veh_num_type'
            }}
            placeholder="请选择车型商品"
            mode="multiple"
            separator={' · '}
            url={'/rental/scm/price/pullDownList'}
            valueKey={'price_mod_code'}
            labelKey={['veh_brand_name', 'veh_series_name', 'veh_model_name', 'veh_num_type']}>

        </SPSelectWithApi>

      </Form.Item>

      {
        firstTypeArr.includes(modifyProject) ?
            < >
              <Form.Item  rules={[
                {
                  required: true,
                  message: '请输入价格'
                },
                { type: 'number',min: 1, max: carMaxLenArr1.includes(modifyProject) ? carMaxNum : dayMaxNum, message: `请输入1-${carMaxLenArr1.includes(modifyProject) ? carMaxNum : dayMaxNum}的正整数` },
              ]} label={priceLabel} name={priceMap[modifyProject]}  style={{
                width: '600px', display:'inline-block' }}>
                <InputNumber
                    style={{width: '100%'}}
                    placeholder="请输入价格" addonAfter={carMaxLenArr1.includes(modifyProject) ? '元' : '元/天'}></InputNumber>
              </Form.Item>
            </>
            : null
      }

      {
        secondTypeArr.includes(modifyProject) ?
            <>
              <Form.Item
                  rules={[{required: true, message: '请选择自定义周中'}]}
                  label={'周末/周中定义'} initialValue={[1, 2, 3, 4]} name={['price_detail', 'weekday', 'day']}  style={{
                width: '600px', }}>
                <Checkbox.Group style={{ width: '100%' }} onChange={onWeekChange}>
                  <Row>
                    {

                      weekArr.map((item: any, index: number) => {
                        return <Col span={6} >
                          <Checkbox value={item.value}>{item.label}</Checkbox>
                        </Col>
                      })
                    }
                  </Row>
                </Checkbox.Group>
              </Form.Item>
              <Form.Item
                  rules={[{required: true, message: '请选择自定义周末'}]}
                  initialValue={[5, 6, 7]} label={'周末'} name={['price_detail', 'weekend', 'day']} style={{
                width: '600px', }}>
                <Checkbox.Group  style={{ width: '100%' }} onChange={onWeekendChange}>
                  <Row>
                    {
                      weekArr.map((item: any, index: number) => {
                        return <Col span={6} >
                          <Checkbox value={item.value}>{item.label}</Checkbox>
                        </Col>
                      })
                    }
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </>
            :
            <></>
      }

      {
        threeTypeArr.includes(modifyProject) ?
            <>
              <Form.Item labelCol={{span: 5}} name={['price_detail', 'holiday']}  style={{
                width: '600px' }}>
                <ChooseRangDay enums={enums}></ChooseRangDay>
              </Form.Item>
            </>
            :
            <></>
      }
      {
        fourTypeArr.includes(modifyProject) ?
            <>
              <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请选择基础保障'
                    }
                  ]}
                  label={'基础保障'} name={['insurance_rule_basic_code']}  style={{
                width: '600px',
                display:'inline-block'
              }}>
                <SPSelectWithApi
                    placeholder="请选择"
                    params={{rule_type: 2, level: 1}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
              </Form.Item> { vipFlag ? '' : <SPButton type="primary" onClick={() => setVipFn(true)}>添加尊享保障</SPButton> }
              <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请选择优享保障'
                    }
                  ]}
                  label={'优享保障'} name={['insurance_rule_vip_code']}  style={{
                width: '600px' }}>
                <SPSelectWithApi
                    placeholder="请选择"
                    params={{rule_type: 2, level: 2}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
              </Form.Item>
              {
                vipFlag ?
                    <>
                      <Form.Item
                          rules={[
                            {
                              required: true,
                              message: '请选择尊享保障'
                            }
                          ]}
                          label={'尊享保障'} name={['insurance_rule_vvip_code']}  style={{
                        display:'inline-block',
                        width: '600px' }}>
                        <SPSelectWithApi
                            placeholder="请选择"
                            params={{rule_type: 2, level: 3}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
                      </Form.Item> <SPButton type="primary" onClick={() => setVipFn(false)}>删除</SPButton>
                    </>
                    : null
              }
            </>
            :<></>
      }
      {
        fiveTypeArr.includes(modifyProject) ?
            <>
              <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请选择预定规则'
                    }
                  ]}
                  label={'预定规则'} name={['pre_booking_rule_code']}  style={{
                width: '600px',
                display:'inline-block'
              }}>
                <SPSelectWithApi
                    placeholder="请选择"
                    params={{rule_type: 1}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
              </Form.Item>
            </>
            :
            <></>
      }
      {
        sixTypeArr.includes(modifyProject) ?
            <>
              <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请选择取消规则'
                    }
                  ]}
                  label={'取消规则'} name={['cancel_rule_code']}  style={{
                width: '600px',
                display:'inline-block'
              }}>
                <SPSelectWithApi
                    placeholder="请选择"
                    params={{rule_type: 3}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
              </Form.Item>
            </>
            :
            <></>
      }
      {
        fuwuzhengce.includes(modifyProject) ?
            <>
              <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请选择服务政策'
                    }
                  ]}
                  label={'服务政策'} name={['serve_rule_code']}  style={{
                width: '600px',
                display:'inline-block'
              }}>
                <SPSelectWithApi
                    placeholder="请选择"
                    params={{rule_type: 4}} url={'/rental/scm/rule/list'} valueKey={'rule_code'} labelKey={'name'}></SPSelectWithApi>
              </Form.Item>
            </>
            :
            <></>
      }
    </>
  );
};

export default BatchSettings;
